'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var constants = require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var ContentTabs = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  margin-left: 39px;\n  min-width: 224px;\n\n  @media (max-width: ", ") {\n    min-width: inherit;\n    margin-left: 2px;\n  }\n"], ["\n  display: flex;\n  margin-left: 39px;\n  min-width: 224px;\n\n  @media (max-width: ", ") {\n    min-width: inherit;\n    margin-left: 2px;\n  }\n"])), constants.DIMENSIONS.SMALL);
var ContentNavItem = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  position: relative;\n  min-width: 38px;\n  margin-right: 36px;\n  font: ", " 14px/16px ", ";\n  color: ", ";\n  cursor: pointer;\n\n  ", "\n\n  @media (max-width: ", ") {\n    padding: 0 2px;\n  }\n"], ["\n  position: relative;\n  min-width: 38px;\n  margin-right: 36px;\n  font: ", " 14px/16px ", ";\n  color: ", ";\n  cursor: pointer;\n\n  ",
    "\n\n  @media (max-width: ", ") {\n    padding: 0 2px;\n  }\n"])), function (_a) {
    var isActive = _a.isActive;
    return (isActive ? 'bold' : 'normal');
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.$white;
}, function (_a) {
    var isActive = _a.isActive, theme = _a.theme;
    return isActive
        && ":before {\n        content: \"\";\n        position: absolute;\n        left: 0;\n        top: 22px;\n        height: 0px;\n        width: 17px;\n        border-bottom: 1px solid " + theme.colors.$white + ";\n  }";
}, constants.DIMENSIONS.SMALL);
var templateObject_1, templateObject_2;

/* eslint-disable no-plusplus */
var DEFAULT_TAB_HEIGHT = 0;
var Y_OFFSET = 10;
var ELEMENT_NOT_FOUND = -1;
var NEIGHBOUR_INDEX_DIFF = 1;
var CURRENT_DIRECTION;
(function (CURRENT_DIRECTION) {
    CURRENT_DIRECTION["ABOVE"] = "above";
    CURRENT_DIRECTION["BELOW"] = "below";
})(CURRENT_DIRECTION || (CURRENT_DIRECTION = {}));
// eslint-disable-next-line max-len
var changeActiveTabOnScroll = function (items, currentId, tabHeight) {
    if (tabHeight === void 0) { tabHeight = DEFAULT_TAB_HEIGHT; }
    var topYPoint = tabHeight + constants.HEADER_HEIGHT + Y_OFFSET;
    var elementFromPoint = document.elementFromPoint(constants.DEFAULT_PAGE_COORDINATES.X, topYPoint);
    // if first visible element includes in array - it's current active tab anyway
    if (items.findIndex(function (uuid) { return uuid === (elementFromPoint === null || elementFromPoint === void 0 ? void 0 : elementFromPoint.id); }) !== ELEMENT_NOT_FOUND) {
        return elementFromPoint === null || elementFromPoint === void 0 ? void 0 : elementFromPoint.id;
    }
    var currentDirection = getDirection(currentId, topYPoint);
    var currentIndex = items.findIndex(function (uuid) { return uuid === currentId; });
    // if current above of top screen border - we must to find nearest visible element with next index from current
    if (currentDirection === CURRENT_DIRECTION.ABOVE) {
        return findVisibleBelow(currentIndex, items, topYPoint);
    }
    // we need to check if some element visible with current anyway (if current bellow bottom border and if we scroll top)
    var visibleAbove = getVisibleAbove(currentIndex, items, topYPoint);
    // return first element in case we scroll top and not found any visible above
    var defaultValue = currentDirection === CURRENT_DIRECTION.BELOW ? items[constants.FIRST_ITEM_INDEX] : currentId;
    return visibleAbove || defaultValue;
};
var isVisible = function (borders, topYPoint) {
    var top = borders.top, bottom = borders.bottom;
    var isBiggerThanScreen = top < topYPoint && bottom > window.innerHeight;
    // eslint-disable-next-line max-len
    var isInsideScreen = (top > topYPoint && top < window.innerHeight) || (bottom > topYPoint && bottom < window.innerHeight);
    return isInsideScreen || isBiggerThanScreen;
};
var getBorders = function (id) {
    var element = document.getElementById(id);
    if (!element) {
        return null;
    }
    var _a = element.getBoundingClientRect(), top = _a.top, bottom = _a.bottom;
    return { top: top, bottom: bottom };
};
var getDirection = function (id, topYPoint) {
    var element = document.getElementById(id);
    if (element) {
        var _a = element.getBoundingClientRect(), top_1 = _a.top, bottom = _a.bottom;
        if (bottom < topYPoint) {
            return CURRENT_DIRECTION.ABOVE;
        }
        if (top_1 > window.innerHeight) {
            return CURRENT_DIRECTION.BELOW;
        }
    }
    return null;
};
var findVisibleBelow = function (currentIndex, items, topYPoint) {
    for (var i = currentIndex + NEIGHBOUR_INDEX_DIFF; i < items.length; i++) {
        var nextId = items[i];
        var nextBorders = getBorders(nextId);
        if (nextBorders && isVisible(nextBorders, topYPoint)) {
            return nextId;
        }
    }
    return items[items.length - NEIGHBOUR_INDEX_DIFF];
};
var getVisibleAbove = function (currentIndex, items, topYPoint) {
    for (var i = currentIndex - NEIGHBOUR_INDEX_DIFF; i >= constants.FIRST_ITEM_INDEX; i--) {
        var previousId = items[i];
        var previousBorders = getBorders(previousId);
        if (previousBorders && isVisible(previousBorders, topYPoint)) {
            return previousId;
        }
    }
    return null;
};

var DEFAULT_OFFSET = 0;
var scrollToElementById = function (id, offset) {
    if (offset === void 0) { offset = DEFAULT_OFFSET; }
    var element = document.getElementById(id);
    if (element) {
        var coordinate = element.getBoundingClientRect().top + window.pageYOffset - constants.HEADER_HEIGHT - offset;
        window.scrollTo({ top: coordinate, behavior: 'smooth' });
    }
};

var CONTENT_NAVIGATION_TABS = {
    HOME: 0,
    DISCOVER: 1,
    SPOTLIGHT: 2,
    UTILITIES: 3,
};
var NAVIGATION_TABS_IDS = [
    constants.CONTENT_HEADING_IDS.HOME,
    constants.CONTENT_HEADING_IDS.DISCOVER,
    constants.CONTENT_HEADING_IDS.SPOTLIGHT,
    constants.CONTENT_HEADING_IDS.UTILITIES,
];
var ContentNavigation = function (_a) {
    var pathname = _a.pathname, contentNavigationHomeLabel = _a.contentNavigationHomeLabel, contentNavigationDiscoverLabel = _a.contentNavigationDiscoverLabel, contentNavigationSpotlightLabel = _a.contentNavigationSpotlightLabel, showUtilityButtonLink = _a.showUtilityButtonLink, spotlightContentCategories = _a.spotlightContentCategories, utilityButtonLinkText = _a.utilityButtonLinkText;
    var _b = tslib_es6.__read(React.useState(CONTENT_NAVIGATION_TABS.HOME), 2), activeTab = _b[0], setActiveTab = _b[1];
    var _c = tslib_es6.__read(React.useState(''), 2), activeTabId = _c[0], setActiveTabId = _c[1];
    React.useEffect(function () { return setActiveTab(CONTENT_NAVIGATION_TABS.HOME); }, [pathname]);
    React.useEffect(function () { return setActiveTabId(NAVIGATION_TABS_IDS[activeTab]); }, [activeTab]);
    var scrollToHome = React.useCallback(function () {
        window.scrollTo(constants.DEFAULT_PAGE_COORDINATES.X, constants.DEFAULT_PAGE_COORDINATES.Y);
        setActiveTab(CONTENT_NAVIGATION_TABS.HOME);
    }, []);
    var scrollToSpotlight = React.useCallback(function () {
        scrollToElementById(constants.CONTENT_HEADING_IDS.SPOTLIGHT);
        setActiveTab(CONTENT_NAVIGATION_TABS.SPOTLIGHT);
    }, []);
    var scrollToDiscover = React.useCallback(function () {
        scrollToElementById(constants.CONTENT_HEADING_IDS.DISCOVER);
        setActiveTab(CONTENT_NAVIGATION_TABS.DISCOVER);
    }, []);
    var scrollToUtilities = React.useCallback(function () {
        scrollToElementById(constants.CONTENT_HEADING_IDS.UTILITIES);
        setActiveTab(CONTENT_NAVIGATION_TABS.UTILITIES);
    }, []);
    var handleActiveTabOnScroll = React.useCallback(function () {
        var newActiveTabId = changeActiveTabOnScroll(NAVIGATION_TABS_IDS, activeTabId);
        if (newActiveTabId !== activeTabId) {
            setActiveTab(NAVIGATION_TABS_IDS.findIndex(function (id) { return id === newActiveTabId; }));
        }
    }, [activeTabId]);
    React.useEffect(function () {
        window.addEventListener('scroll', handleActiveTabOnScroll);
        return function () {
            window.removeEventListener('scroll', handleActiveTabOnScroll);
        };
    }, [activeTabId, handleActiveTabOnScroll]);
    return (React__default.createElement(ContentTabs, { "data-testid": "content-tabs" },
        React__default.createElement(ContentNavItem, { onClick: scrollToHome, isActive: activeTab === CONTENT_NAVIGATION_TABS.HOME, "data-testid": "home-tab" }, contentNavigationHomeLabel),
        showUtilityButtonLink && (React__default.createElement(ContentNavItem, { onClick: scrollToUtilities, isActive: activeTab === CONTENT_NAVIGATION_TABS.UTILITIES, "data-testid": "utilityButton-tab" }, utilityButtonLinkText)),
        React__default.createElement(ContentNavItem, { isActive: activeTab === CONTENT_NAVIGATION_TABS.DISCOVER, onClick: scrollToDiscover, "data-testid": "discover-tab" }, contentNavigationDiscoverLabel),
        (spotlightContentCategories === null || spotlightContentCategories === void 0 ? void 0 : spotlightContentCategories.length) ? (React__default.createElement(ContentNavItem, { isActive: activeTab === CONTENT_NAVIGATION_TABS.SPOTLIGHT, onClick: scrollToSpotlight, "data-testid": "spotlight-tab" }, contentNavigationSpotlightLabel)) : null));
};
ContentNavigation.defaultProps = {
    spotlightContentCategories: [],
    contentNavigationSpotlightLabel: '',
    showUtilityButtonLink: false,
    utilityButtonLinkText: null,
};

exports.ContentNavigation = ContentNavigation;
